import { Navigate, Outlet, useLocation } from "react-router-dom";
import useUserCredentials from "../../utils/hooks/user/useUserCredentials";
import { LoginStatus } from "../../utils/store/reducer/slices/userReducer";

/**
 * Restricts access to child routes based on the stored access token
 */
const ProtectedRoute = ({ fallbackRoute }: { fallbackRoute?: string }) => {
  const { loginStatus } = useUserCredentials();
  const location = useLocation();

  // If the access token is invalid - redirect back to the login page
  return loginStatus === LoginStatus.SIGNED_IN ? (
    <Outlet />
  ) : (
    <Navigate
      to={fallbackRoute || "/login"}
      state={{ from: location }}
      replace
    />
  );
};

export default ProtectedRoute;
